import React from 'react';

import { Container } from '../common';
import type { EventTypeEvaluationsContextType } from '../context';
import { EventTypeEvaluationsProvider } from '../context';
import { TransactionTabs } from './TransactionTabs';
import { TransactionCards } from './TransactionCards';
import { useFetchedUserContext } from '~/helpers/hooks';
import { AiSummaryCard } from '~/application-review/AiSummaryCard/AiSummaryCard';

const Transaction: React.FC<EventTypeEvaluationsContextType> = props => {
  const { isJourneyApplicationPage, evaluation } = props;
  const {
    feature_flags: {
      'rule-explainability-phase': ruleExplainabilityPhase,
    },
  } = useFetchedUserContext();

  return (
    <EventTypeEvaluationsProvider {...props}>
      <Container
        style={isJourneyApplicationPage ? {
          paddingTop: 0,
        } : {}}
      >
        <AiSummaryCard token={evaluation.evaluation_token} />
        {(ruleExplainabilityPhase && ruleExplainabilityPhase > 0 ? (
          <TransactionTabs />
        ) : (
          <TransactionCards />
        ))}
      </Container>
    </EventTypeEvaluationsProvider>
  );
};

export default Transaction;
